export default __webpack_public_path__ + "static/media/icons8-mysql-logo.e709ed5e.svg";